//
//
//
//

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DatasetComponent,
} from 'echarts/components'
import VChart from 'vue-echarts'

use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DatasetComponent,
  BarChart,
  LineChart,
  CanvasRenderer,
])

export default {
  components: {
    VChart,
  },
  props: {
    dataset: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const colors = ['#dc5014', '#03b8df']

    return {
      option: {
        color: colors,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
          },
          backgroundColor: '#5e5f5e',
          borderColor: '#5e5f5e',
          padding: [6, 8],
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
          formatter(datas) {
            let text = `${datas[0].value[0]}<br />`

            datas.map((data, index) => {
              let value = data.value[index + 1]

              switch (data.seriesIndex) {
                case 0:
                  value += '円'
                  break
                case 1:
                  value += '個'
                  break
                default:
                  break
              }

              text += `${data.seriesName}: ${value}<br />`

              return data
            })

            return text
          },
        },
        grid: {
          left: '56px',
          right: '48px',
        },
        legend: {},
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              formatter(value) {
                return value.replace(/.+\//, '')
              },
            },
            splitLine: {
              show: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '円',
            min: 0,
            max: 20000,
            interval: 2000,
            position: 'left',
            axisLine: {
              show: true,
            },
          },
          {
            type: 'value',
            name: '個',
            min: 0,
            max: 100,
            interval: 10,
            position: 'right',
            axisLine: {
              show: true,
            },
          },
        ],
        dataset: this.dataset,
        series: [
          {
            type: 'bar',
            barWidth: 8,
            datasetIndex: 0,
            yAxisIndex: 0,
            itemStyle: {
              opacity: 0.7,
            },
          },
          {
            type: 'bar',
            barWidth: 8,
            datasetIndex: 0,
            yAxisIndex: 1,
            itemStyle: {
              opacity: 0.7,
            },
          },
        ],
      },
    }
  },
  watch: {
    dataset(newValue) {
      this.option.dataset = newValue
    },
  },
}
